import { createSlice } from "@reduxjs/toolkit";
import { createDepartment, getAllDepartments, updateDepartment, toggleActiveDepartment, getDepartmentSuggestion, updateDepartmentPrice, getAllDepPrice, deleteDepPrice } from "./departmentThunk";

const initialState = {
  departments: [],
  createdDepartment: null,
  createdDepartmentError: null,
  getAllDepartment: null,
  getAllDepartmentError: null,
  updatedDepartment: null,
  updatedDepartmentError: null,
  toggleActiveDept: null,
  toggleActiveDeptError: null,
  departmentSuggestion: null,
  departmentSuggestionError: null,
  updateDepPriceSuccess: null,
  updateDepPriceErr: null,
  getDepPriceSuccess: null,
  getDepPriceErr: null,
  delDepPriceSuccess: null,
  delDepPriceErr: null,
};

const departmentSlice = createSlice({
  name: "department",
  initialState,
  reducers: {
    resetCreatedDepartment(state) {
      state.createdDepartmentError = null;
      state.createdDepartment = null;
    },
    resetUpdateDepartment(state) {
      state.updatedDepartment = null;
      state.updatedDepartmentError = null;
    },
    resetGetAllDepartment(state) {
      state.getAllDepartmentError = null;
      state.getAllDepartment = null;
    },
    resetToggleActiveDept(state) {
      state.toggleActiveDept = null;
      state.toggleActiveDeptError = null;
    },
    resetDeptSuggestion(state) {
      state.departmentSuggestion = null;
      state.departmentSuggestionError = null;
    },
    resetUpdateDepPrice(state) {
      state.updateDepPriceErr = null;
      state.updateDepPriceSuccess = null;
    },
    resetGetDepPrice(state) {
      state.getDepPriceErr = null;
      state.getDepPriceSuccess = null;
    },
    resetDelDepPrice(state) {
      state.delDepPriceErr = null;
      state.delDepPriceSuccess = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // CREATE DEPARTMENT (SPECIALITY)
      .addCase(createDepartment.fulfilled, (state, action) => {
        state.createdDepartment = action.payload;
      })
      .addCase(createDepartment.rejected, (state, action) => {
        state.createdDepartmentError = action.error.message;
      })
      // GET ALL DEPARTMENT (SPECIALITYY)
      .addCase(getAllDepartments.fulfilled, (state, action) => {
        state.getAllDepartment = action.payload;
      })
      .addCase(getAllDepartments.rejected, (state, action) => {
        state.getAllDepartmentError = action.error.message;
      })
      // GET ALL suggesstion (SPECIALITYY)
      .addCase(getDepartmentSuggestion.fulfilled, (state, action) => {
        state.departmentSuggestion = action.payload;
      })
      .addCase(getDepartmentSuggestion.rejected, (state, action) => {
        state.departmentSuggestionError = action.error.message;
      })
      // UPDATE DEPARTMENT (SPECIALITY)
      .addCase(updateDepartment.fulfilled, (state, action) => {
        state.updatedDepartment = action.payload;
      })
      .addCase(updateDepartment.rejected, (state, action) => {
        state.updatedDepartmentError = action.error.message;
      })
      // TOGGLE ACTIVATE DEPARTMENT (SPECIALITY)
      .addCase(toggleActiveDepartment.fulfilled, (state, action) => {
        state.toggleActiveDept = action.payload;
      })
      .addCase(toggleActiveDepartment.rejected, (state, action) => {
        state.toggleActiveDeptError = action.error.message;
      })
      // ADD OR UPDATE DEPARTMENT PRICE
      .addCase(updateDepartmentPrice.fulfilled, (state, action) => {
        state.updateDepPriceSuccess = action.payload;
      })
      .addCase(updateDepartmentPrice.rejected, (state, action) => {
        state.updateDepPriceErr = action.error.message;
      })
      // GET ALL DEPARTMENT PRICE
      .addCase(getAllDepPrice.fulfilled, (state, action) => {
        state.getDepPriceSuccess = action.payload;
      })
      .addCase(getAllDepPrice.rejected, (state, action) => {
        state.getDepPriceErr = action.error.message;
      })
      // DELETE DEPARTMENT PRICE
      .addCase(deleteDepPrice.fulfilled, (state, action) => {
        state.delDepPriceSuccess = action.payload;
      })
      .addCase(deleteDepPrice.rejected, (state, action) => {
        state.delDepPriceErr = action.error.message;
      });
  },
});

export const { resetCreatedDepartment, resetUpdateDepartment, resetGetAllDepartment, resetToggleActiveDept, resetDeptSuggestion, resetUpdateDepPrice, resetGetDepPrice, resetDelDepPrice } =
  departmentSlice.actions;
export default departmentSlice.reducer;
